$(document).ready(function(){
  $(document).on('click','.size-chart_pop',function(){
    $('body').addClass('active_size');
    // var product_title = $('.product-single__title').text();
    // var selvar = $('.single-option-selector').find('option:selected').text();
    // $('.size-guide-snippet').find('.prod-selected').html('<h3>'+product_title+'<span> - '+selvar+'</span></h3>');
    $('.sizeChart').css({'display':'flex'});
  });
  $(document).on('click','.modal__close',function(){
    $('body').removeClass('active_size');
   $('.sizeChart').css({'display':'none'});
  });

  setTimeout(function(){ updateColor(); }, 1000);
  $(document).on('click','.swatchColor',function(){
   updateColor();
  });
  function updateColor(){
    var sel_color= $('.currentSwatch .innerText').text();
    $('.color_swatch').text(sel_color); 
  }

  setTimeout(function(){ 
  $('.color-swatch.opt-all-season').trigger('click');
    console.log('herer')
  }, 300); 
  
  
});